import { app } from "js/namespaces";
import { ds } from "js/core/models/dataService";
import { AssetType } from "common/constants";
import { builtInFonts } from "common/fontConstants";
import { fontManager } from "js/core/services/fonts";
import { fontsActions, UPDATE_THEME } from "../themeEditor_types";

export const updateTheme = newThemeProps => {
    return {
        type: UPDATE_THEME,
        payload: newThemeProps
    };
};

export const fetchFonts = orgId => {
    return {
        types: [
            fontsActions.fetchStart,
            fontsActions.fetchSuccess,
            fontsActions.fetchError
        ],
        promise: async () => {
            const fontAssets = await ds.assets.getAssetsByType(AssetType.FONT, orgId);

            const fontIds = fontAssets.map(({ id }) => id);
            fontIds.push(...Object.keys(builtInFonts));

            // Making sure we load fonts from the current theme because they
            // may not be in userAssets if it's a team theme
            const themeFontIds = app.currentTheme.getFontIds();
            themeFontIds.forEach(fontId => {
                if (!fontIds.includes(fontId)) {
                    fontIds.push(fontId);
                }
            });

            return Promise.all(fontIds.map(async fontId => fontManager.loadFont(fontId)));
        }
    };
};
